import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import PreviewPage from "../Preview/Preview";

export default function PublicPages() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [isLoading, setIsLoading] = useState(true);
    const [propertyData, setPropertyData] = useState(null);

    const propertyId = queryParams.get("propertyId");

    useEffect(() => {
        if (propertyId) {
            getPropertyById();
        }
    }, [propertyId]);
    const getPropertyById = async () => {
        if (propertyId) {
            setIsLoading(true);
            try {
                const response = await axios.get(`${config.get("API_URL")}/properties/get_public_property/${propertyId}`);
                setPropertyData(response);
            } catch (error) {
                console.log("Error::", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    if (isLoading || !propertyData) {
        return <div>Loading</div>;
    }
    return <div>{propertyData ? <PreviewPage propertyId={propertyId} publicProperty={propertyData} /> : "No Property against this id"}</div>;
}
